import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'failure-analysis';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CHANGE_PAGINATION = `${NAMESPACE}/CHANGE_PAGINATION`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const SET_JOBS_OWNER = `${NAMESPACE}/SET_JOB_OWNER`;
export const SET_OWNER_FROM_QUERYSTRING = `${NAMESPACE}/SET_OWNER_FROM_QUERYSTRING`;

export const GET_FAILURE_TESTS = createApiNamespacedConstants('GET_FAILURE_TESTS');
export const GET_JOBS_OWNERS = createApiNamespacedConstants('GET_JOBS_OWNERS');
export const GET_ROOT_CAUSES = createApiNamespacedConstants('GET_ROOT_CAUSES');
